import { QueryHookOptions, useQuery } from '@apollo/client';

import { USER_BY_SLUG_QUERY } from './queries';
import { User } from './types';

export const useUserBySlug = (slug?: string, options?: QueryHookOptions) =>
  useQuery<{ userBySlug: User }>(USER_BY_SLUG_QUERY, { ...options, variables: { slug } });
